import { GenericDatalayerEvent } from './generic';
import { PageViewEvent } from './pageview';
import { PageViewProductEvent } from './pageview-product';
import { PageViewSearchEvent } from './pageview-search';
import { FreightDatalayer } from './freight-calculate';
import { ModalOpenDatalayer } from './modal-open';

declare global {
  interface Window {
    dataLayer: [
      | GenericDatalayerEvent
      | FreightDatalayer
      | ModalOpenDatalayer
      | PageViewEvent
      | PageViewSearchEvent
      | PageViewProductEvent
    ];
  }
}

export type eventData = { [event: string]: Array<Event> };

export const PAGETYPES: Pagetypes = {
  search: 'Busca',
  home: 'Home',
  product: 'Produto',
  services: 'GarantiaProduto',
  newsletter: 'Newsletter',
  review: 'Avaliacao',
  report: 'Denuncie',
  'store-list': 'NPL:Home',
  'store-offers': 'NPL:Loja',
  'open-store-search': 'NPL:Busca',
};

interface Pagetypes {
  [index: string]: string;
}

export interface parsedQsType {
  [name: string]: any;
}
